module.exports = __webpack_public_path__ + "44cfab52123590f50980cfed964edf18.svg";